import React, { useState } from 'react';

import IconEyeClosed from '@repo/ui-icons/IconEyeClosed';
import IconEyeOpened from '@repo/ui-icons/IconEyeOpened';

import { Button } from '../../Button';
import { BasicInput } from '../BasicInput/BasicInput';
import { RootWrapper } from '../RootWrapper';
import { Slot } from '../Slot';
import type { PasswordInputProps } from '../types';

import { useBasicTextInputProps } from './useBasicTextInputProps';

const getButtonSize = (inputSize: PasswordInputProps['size']) => {
  if (inputSize === 's' || inputSize === 's-condensed') {
    return 'xs';
  }
  if (inputSize === 'm') {
    return 's';
  }
  return 'm';
};

/**
 * Provides a password input with optional embedded slot content and a toggle button to show/hide the password.
 */
export const PasswordInput = React.forwardRef<
  HTMLInputElement,
  PasswordInputProps
>(({ ...props }, ref) => {
  const [isPasswordType, setIsPasswordType] = useState(true);
  const { basicInputProps } = useBasicTextInputProps(props);

  return (
    <RootWrapper {...props}>
      <BasicInput
        ref={ref}
        {...basicInputProps}
        data-testid="password-input"
        type={isPasswordType ? 'password' : 'text'}
      />
      <Slot>
        <Button
          ariaLabel="Toggle password visibility"
          leftIcon={isPasswordType ? IconEyeOpened : IconEyeClosed}
          name="togglePasswordVisibilityButton"
          size={getButtonSize(props.size)}
          variant="ghost"
          onClick={() => setIsPasswordType((current) => !current)}
        />
      </Slot>
    </RootWrapper>
  );
});
PasswordInput.displayName = 'PasswordInput';
